import React from 'react';
import { Volume2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { cn } from '@/lib/utils';

interface AudioDevice {
    deviceId: string;
    label: string;
}

interface AudioDevices {
    inputs: AudioDevice[];
    outputs: AudioDevice[];
    selectedInput?: string | null;
    selectedOutput?: string | null;
}

interface AudioSettingsProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    audioDevices: AudioDevices;
    onInputChange: (deviceId: string) => void;
    onOutputChange: (deviceId: string) => void;
}

export const AudioSettings: React.FC<AudioSettingsProps> = ({
    open,
    onOpenChange,
    audioDevices,
    onInputChange,
    onOutputChange,
}) => (
    <Popover open={open} onOpenChange={onOpenChange}>
        <PopoverTrigger asChild>
            <Button
                variant="ghost"
                className={cn(
                    "w-[68px] h-[68px] rounded-full bg-muted hover:bg-muted/80 border active:scale-95 transition-all duration-150",
                    open && "bg-muted/60",
                )}
            >
                <Volume2 className="w-5 h-5 text-muted-foreground" />
            </Button>
        </PopoverTrigger>
        <PopoverContent className="w-64" align="end">
            <div className="space-y-3">
                <div>
                    <label className="text-sm font-medium mb-1.5 block">Microphone</label>
                    <select
                        className="w-full p-2 text-sm border rounded-md bg-background"
                        value={audioDevices.selectedInput || ''}
                        onChange={(e) => onInputChange(e.target.value)}
                    >
                        {audioDevices.inputs.map(device => (
                            <option key={device.deviceId} value={device.deviceId}>
                                {device.label}
                            </option>
                        ))}
                    </select>
                </div>
                <div>
                    <label className="text-sm font-medium mb-1.5 block">Speaker</label>
                    <select
                        className="w-full p-2 text-sm border rounded-md bg-background"
                        value={audioDevices.selectedOutput || ''}
                        onChange={(e) => onOutputChange(e.target.value)}
                    >
                        {audioDevices.outputs.map(device => (
                            <option key={device.deviceId} value={device.deviceId}>
                                {device.label}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
        </PopoverContent>
    </Popover>
);
